import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components";

//
import Navbar from "./Navbar";
import { useScrollDirection } from "../../hooks/useScrollDirection";
import { useWindowPageOffset } from "../../hooks/useWindowPageOffsets";

export default function FixedNavbar() {
  const [hideNavbar, setHideNavbar] = useState(false);
  const scrollDirection = useScrollDirection();
  const { yOffset } = useWindowPageOffset();

  useEffect(() => {
    if (yOffset < 110) {
      setHideNavbar(false);
    } else if (scrollDirection === "up") {
      setHideNavbar(true);
    }
    if (scrollDirection === "down") {
      setHideNavbar(false);
    }
  }, [scrollDirection, yOffset]);

  return (
    <StyledFixedNavbar $hideNavbar={hideNavbar}>
      <Navbar />
    </StyledFixedNavbar>
  );
}

const StyledFixedNavbar = styled.div`
  position: fixed;
  top: 0px;
  width: 100%;
  transform: translateY(-110%);
  transition: 0.75s ease;
  z-index: 4;

  ${({ $hideNavbar }) =>
    $hideNavbar &&
    css`
      transform: translateY(0%);
    `}
`;
